import React from "react"

export const PadlockIcon = (props) => {
  return (
    <svg
      width={30}
      height={30}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        style={{
          fill: "none",
        }}
        d="M0 0h24v24H0z"
      />
      <path
        style={{ fill: "#034055" }}
        d="M6.89 4.92a4.93 4.93 0 0 1 9.85 0v5.49a4.93 4.93 0 0 1-9.85 0Z"
      />
      <path
        style={{ fill: "#ffffff" }}
        d="M11.81 2a2.89 2.89 0 0 0-2.89 2.92v5.33a2.89 2.89 0 1 0 5.78 0V4.92A2.88 2.88 0 0 0 11.81 2Z"
      />
      <path
        d="M4.92 10.13H18.7L20.08 24H3.54Z"
        style={{
          fill: "#ffd62e",
        }}
      />
      <path style={{ fill: "#ffffff" }} d="M11.28 17.33h1.33v2.94h-1.33Z" />
      <path
        style={{ fill: "#034055" }}
        d="M10.48 16.53h2.93v4.54h-2.93Zm.8.8v2.94h1.33v-2.94Z"
      />
    </svg>
  )
}
